import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { injectIntl, intlShape } from 'react-intl';
import Modal from '../../../components/modal/index';
import ConfirmationMessage from '../../../components/confirmation-message/index';
import UploadSummary from '../../../components/upload-summary/index';
import { Warning } from '../../../helpers/icon-dictionary';
import messages from '../messages';
import css from '../index.scss';

const RollOverError = (props) => {
    const { closeUploadErrorModal,
        message,
        showUploadModal,
        intl,
        validationErrors,
        showDataGrid,
        isServerError,
        fileSize } = props;

    let errorView = <div />;

    const GenerateErrorRow = (errors) => {
        let errorMessages = [];

        errorMessages = errors.map(error => (<div className={css.rowNumber} key={uniqueId('UploadValidationMessages')}>
            {intl.formatMessage(messages.row)}&nbsp;{error.rowReference}
            <div className={css.message}>{error.message}</div>
        </div>));

        return errorMessages;
    };

    if (!showDataGrid) {
        if (validationErrors.length) {
            errorView = (<UploadSummary
                handleOnBack={closeUploadErrorModal}
                icon={Warning}
                message={intl.formatMessage(messages.errorsInYourFile)}
                rollOverValidationPage>{GenerateErrorRow(validationErrors)}</UploadSummary>);
        } else {
            if (isServerError) {
                message.header = intl.formatMessage(messages.somethingWentWrong);
                message.body = intl.formatMessage(messages.pleaseTryUploadingAgain);
            } else if (fileSize > 1) {
                message.header = intl.formatMessage(messages.fileSizeMessage);
                message.body = '';
            }

            errorView = (
                <ConfirmationMessage
                    handleOnCloseModal={closeUploadErrorModal}
                    icon={Warning}
                    title={message.header}>
                    {message.body}
                </ConfirmationMessage>
            );
        }
    }

    return (<Modal show={showUploadModal}>
        {errorView}
    </Modal>);
};

RollOverError.propTypes = {
    intl: intlShape.isRequired,
    closeUploadErrorModal: PropTypes.func,
    message: PropTypes.object,
    showUploadModal: PropTypes.bool,
    validationErrors: PropTypes.array,
    showDataGrid: PropTypes.bool,
    isServerError: PropTypes.bool,
    fileSize: PropTypes.number
};

export default injectIntl(RollOverError);



// WEBPACK FOOTER //
// ./app/components/roll-over/modals/error.js